import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { FormSelect } from '@getro/rombo';
import { FormikAutoSubmit } from '../../../../components/atoms/formikAutoSubmit';

const movementTypeOptions = [
  { value: 'hire', label: 'Hire' },
  { value: 'promotion', label: 'Promotion' },
  { value: 'departure', label: 'Departure' },
];

export const MovementTypeFilter = ({ value, setFilters }) => {
  const onSubmit = ({ movementType }) => {
    setFilters({ movementType: movementType || [] });
  };

  return (
    <Formik initialValues={{ movementType: value || [] }} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="movementType"
          label="Movement type"
          placeholder="All"
          component={FormSelect}
          options={movementTypeOptions}
          multiple
          size="small"
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

MovementTypeFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

MovementTypeFilter.defaultProps = {
  value: [],
};
